import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { getTotalTreeCodes } from '../api/treeCodes.api';
import { ITreeCode, IGetTreeCodes, ITreeSubcode, IGetTreeSubcodes } from '../models/treeCodes.model';

interface ITreeCodeState {
  treeCodes: ITreeSubcode[];
  isLoading: boolean;
  error?: AxiosError | string;
}

const initialState: ITreeCodeState = {
  treeCodes: [],
  isLoading: false,
};

const treeCodeDataSlicer = createSlice({
  name: 'treeCode',
  initialState,
  reducers: {
    getTreeCodesStart: (state: ITreeCodeState) => {
      state.treeCodes = [];
      state.isLoading = true;
      state.error = undefined;
    },
    getTreeCodesSuccess: (
      state: ITreeCodeState,
      action: PayloadAction<IGetTreeSubcodes>,
    ) => {
      state.treeCodes = action.payload.data;
      state.isLoading = false;
      state.error = undefined;
    },
    getTreeCodesFailure: (
      state: ITreeCodeState,
      action: PayloadAction<AxiosError | string>,
    ) => {
      state.treeCodes = [];
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const {
  getTreeCodesStart,
  getTreeCodesSuccess,
  getTreeCodesFailure,
} = treeCodeDataSlicer.actions;

export default treeCodeDataSlicer.reducer;

export const doGetTreeCodes = (): any => async (dispatch: any) => {
  try {
    dispatch(getTreeCodesStart());
    const response = await getTotalTreeCodes();
    dispatch(getTreeCodesSuccess(response.data));
    return response;
  } catch (e: any) {
    dispatch(getTreeCodesFailure(e.response?.data?.data || e.message));
    return e.response;
  }
};
